module.exports = __webpack_public_path__ + "img/bird.818df3f9.svg";